import type { JSX } from 'react'
import type { ToastClassnames } from 'sonner'
import { cn } from '@ttab/elephant-ui/utils'
import type { ToastActionProps } from '../types'
import { ToastActions } from '../ToastActions'

/**
 * Toast options for several shortcuts. Adds the `flex-wrap` the toast needs for the
 * action row to sit below the title.
 */
export const withToastActions = (
  actions: ToastActionProps[],
  classNames?: ToastClassnames
): { classNames: ToastClassnames, action: JSX.Element } => ({
  classNames: { ...classNames, toast: cn('flex-wrap', classNames?.toast) },
  action: <ToastActions actions={actions} />
})
